import { render, staticRenderFns } from "./meetings.vue?vue&type=template&id=08ce864d"
import script from "./meetings.vue?vue&type=script&lang=ts"
export * from "./meetings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports